export default {
  swap: {
    id: 'checkout_summary_tradein_title',
    defaultMessage: 'Trade-in value',
  },
}
